// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"b474ca3c","450":"d6256a4b","488":"8ad6c3b9","867":"4e1c73d3"}[chunkId] + ".chunk.js";
};